import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const useLoadingDelay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const status = useSelector((state) => state.checkArsStatus.status);

  const delay = useCallback(() => {
    const timer = setTimeout(() => {
      if (status !== "expired") {
        navigate("/landing");
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      delay();
    }
  }, [delay]);
};

export default useLoadingDelay;
